import { IAuthor, IdefaultSearchParams } from "@/models/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { SERVER_API_URL } from "src/config/constants";

const INITIAL_STATE = {
  loading: false,
  errorMessage: null as unknown as string,
  fetchSuccess: false,
  fetchFailure: false,
  search: null as unknown as IAuthor[],
  refresh: 0,
};

export type AuthorsSearchState = Readonly<typeof INITIAL_STATE>;

export const getAuthors = createAsyncThunk(
  "catalog/search",
  async (params: IdefaultSearchParams, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<IAuthor[]> = await axios.post(
        `${SERVER_API_URL}/api/authors/search`,
        params
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const authorsSearchSlice = createSlice({
  name: "post",
  initialState: INITIAL_STATE,
  reducers: {
    refreshAuthorsSearch(state) {
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthors.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAuthors.fulfilled, (state, { payload }) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
          search: payload,
        };
      })
      .addCase(getAuthors.rejected, (state) => {
        return {
          ...state,
          loading: false,
          fetchFailure: true,
        };
      });
  },
});

const { actions } = authorsSearchSlice;
export const { refreshAuthorsSearch } = actions;

export default authorsSearchSlice.reducer;
